import { render } from "./FooterBlock.vue?vue&type=template&id=13709902&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"

import "./FooterBlock.vue?vue&type=style&index=0&id=13709902&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13709902"]])

export default __exports__